import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { PermissionService } from "../../services/api/permission/permission.service";

export const tenantGuard: CanActivateFn = () => {
  const permissions = inject(PermissionService);
  const router = inject(Router);
  if (permissions.hasPermission(permissions.allPermissions.ASSET_MASTER_DATA_CREATE)) {
    return true;
  } else {
    router.navigate(["/dashboard/home"]);
    return false;
  }
};
